export const ActionTypes = {
  SET_COMPANIES: 'SET_COMPANIES',
  UPDATE_COMPANY: 'UPDATE_COMPANY',
  SET_SELECTED_COMPANY: 'SET_SELECTED_COMPANY',
  TOGGLE_COMPANY_MODAL: 'TOGGLE_COMPANY_MODAL',
};
